export function initBlogPost() {
    console.log('Blog post initialized!')
}
